import { createSelector } from 'reselect';
import _ from 'lodash';

export const getPresence = state => state.presence;

export const isUserOnline = userUid =>
  createSelector(getPresence, presence => !_.isNil(presence.users[userUid]));
